import { render, staticRenderFns } from "./logged.vue?vue&type=template&id=be31de22&scoped=true&"
import script from "./logged.vue?vue&type=script&lang=js&"
export * from "./logged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be31de22",
  null
  
)

export default component.exports